import PropTypes from 'prop-types';
import { ActionIcon } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import {
  setShowCredentialForm,
  setCurrentSelectedCredentialId,
  setCredentialFormUpdateMode,
} from '../../actions';

import styles from './PencilButton.module.scss';

const PencilButton = ({ credentialId }) => {
  const dispatchShowCredentialForm = useAction(setShowCredentialForm);
  const dispatchSetCurrentSelectedCredential = useAction(setCurrentSelectedCredentialId);
  const dispatchSetCredentialFormUpdateMode = useAction(setCredentialFormUpdateMode);

  const handleIconClick = () => {
    dispatchSetCurrentSelectedCredential(credentialId);
    dispatchSetCredentialFormUpdateMode();
    dispatchShowCredentialForm();
  };

  return (
    <div className={styles.pencilIcon}>
      <ActionIcon icon="fa-solid fa-pen" onClick={() => handleIconClick()} />
    </div>
  );
};

PencilButton.propTypes = {
  credentialId: PropTypes.string,
};

PencilButton.defaultProps = {
  credentialId: '',
};

export default PencilButton;
